export default __webpack_public_path__ + "static/logoKolabsMain-c727606e3e7bf3b606a3bd9e84fb5db9.png";